// extracted by mini-css-extract-plugin
export default {"root":"BaseEdit-modules__root__Y0yq8","show-keyframe":"BaseEdit-modules__show-keyframe__g6Zz3"};